<template>
  <div class="importInStock">
    <div class="row-me row-center">
      <div class="title1">选择库房：</div>
      <div class="flex1">
        <el-select v-model="selectHouse" placeholder="请选择" style="width: 100%;" filterable clearable>
          <el-option v-for="item in houseArray" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="title1 margin-left50">入库类型：</div>
      <div class="flex1">
        <el-select v-model="selectType" placeholder="请选择" style="width: 100%;" filterable clearable>
          <el-option v-for="item in typeArray" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="row-me margin-top20">
      <div class="title1">填写备注：</div>
      <div class="flex1">
        <el-input type="textarea" placeholder="请输入(选填)" style="width: 100%;" clearable v-model="remark"
                  maxlength="500" show-word-limit autosize></el-input>
      </div>
    </div>
    <div class="row-me margin-top20">
      <div class="title1">模板下载：</div>
      <div class="column-me flex1">
        <div class="row-me row-center grey-div">
          <img src="../../assets/img/excel.png" class="img-excel">
          <div class="name flex1">导入入库单模板</div>
          <div class="btn-blank-blue width110 btn-height40 margin-right20" @click="clickDownload">下载</div>
        </div>
        <div class="row-me row-center margin-top10">
          <img src="../../assets/img/tanhao.png" class="img-icon">
          <div class="title2 margin-left5">请先下载我们提供给您的模板，修改填入数据后再导入文件。</div>
        </div>
      </div>
    </div>
    <div class="row-me row-center margin-top20">
      <div class="title1">导入文件：</div>
      <div class="row-me row-center flex1">
        <div class="file-div">{{ fileName }}</div>
        <el-upload ref="upload" action="" accept=".xls,.xlsx" :show-file-list="false" :auto-upload="false"
                   :http-request="uploadFile" :on-change="fileChange" :limit="2">
          <template #trigger>
            <div class="btn-blank width110 btn-height40 margin-left20">选择文件</div>
          </template>
          <!-- 不加默认上传按钮会报错 -->
          <div class="btn-blue width110 btn-height40" @click="clickOk" v-show="false">确定</div>
        </el-upload>
      </div>
    </div>
    <div class="row-me row-center flex-end1 margin-top100">
      <div class="btn-blank width110 btn-height40" @click="clickCancel">取消</div>
      <el-button class="btn-blue width110 margin-left20" @click="clickOk" :disabled="isSaving">确定</el-button>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      fileName: '',
      houseArray: [],
      selectHouse: '',
      selectType: '',
      typeArray: [], //入库类型集合
      remark: '',
      isSaving: false,
    }
  },
  // html加载完成之前
  created() {
    this.getHouseList()
    this.getInStorageType()
  },
  // html加载完成后执行。
  mounted() {

  },
  // 事件方法执行
  methods: {
    //下载
    clickDownload() {
      window.open(this.$axios.defaults.baseURL + '/template/导入入库单模板.xlsx')
    },
    //确定
    clickOk() {
      if (this.isSaving) return;
      this.isSaving = true
      if (this.$method.isEmpty(this.selectHouse)) {
        this.$message.error('请先选择库房')
        this.isSaving = false
        return
      }
      if (this.$method.isEmpty(this.selectType)) {
        this.$message.error('请先选择入库类型')
        this.isSaving = false
        return
      }
      if (this.fileName === '' || this.fileName === null) {
        this.$message.error('请先选择文件')
        this.isSaving = false
        return
      }
      this.$refs.upload.submit()
    },
    //取消
    clickCancel() {
      this.bus.$emit('importSuccess')
    },
    //文件状态改变
    fileChange(file, fileList) {
      // 解决上传文件limit为1时，不触发onchange方法，在第二次调用的时候将第一个文件删除
      if (fileList.length > 1) {
        fileList.shift();
      }
      this.fileName = file.name
    },
    //上传
    uploadFile(param) {
      this.bus.$emit('loading', 1)
      let file = param.file;
      let formData = new FormData();
      formData.append("file", file);
      this.$uploadFileRequest('/admin/stock/importInStorage?phaId=' + this.selectHouse + '&type=' + this.selectType
          + '&remark=' + this.remark, formData).then((res) => {
        this.bus.$emit('loading', 0)
        if (res) {
          this.$message.success(res.message)
          this.bus.$emit('importSuccess', 'refresh')
        }
        this.isSaving = false
      }).catch((error) => {
        this.bus.$emit('loading', 0)
        console.log(error)
        this.isSaving = false
      })
    },
    //获取库房列表
    getHouseList() {
      this.$getRequest('/admin/pharmacy/listAll', {}).then((res) => {
        if (res) {
          this.houseArray = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取入库类型
    getInStorageType() {
      this.$getRequest('/admin/dict/getInStorageType', {}).then((res) => {
        if (res) {
          this.typeArray = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
}
</script>

<style lang="scss" scoped>
.importInStock {
  font-size: 18px;
  color: #252630;
  margin: 10px;

  .title1 {
    width: 100px;
  }

  .grey-div {
    height: 100px;
    background-color: #F5F5F5;

    .img-excel {
      width: 50px;
      height: 60px;
      object-fit: scale-down;
      margin-left: 20px;
    }

    .name {
      font-size: 16px;
      margin-left: 20px;
    }
  }

  .img-icon {
    width: 16px;
    height: 16px;
    object-fit: scale-down;
  }

  .title2 {
    font-size: 14px;
    color: #A9B6C4;
  }

  .file-div {
    width: 400px;
    height: 40px;
    line-height: 40px;
    padding: 0 10px;
    border-radius: 4px;
    border: 1px solid #E5E9ED;
  }
}
</style>
